import { render, staticRenderFns } from "./CommissionUploadHistory.vue?vue&type=template&id=53b9ded0&"
import script from "./CommissionUploadHistory.vue?vue&type=script&lang=js&"
export * from "./CommissionUploadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports